"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeCustomersApi = activeCustomersApi;
exports.deleteApi = deleteApi;
exports.editApi = editApi;
exports.empListApi = empListApi;
exports.exportUserFudou = exportUserFudou;
exports.fudouConvert = fudouConvert;
exports.fudouConvertTips = fudouConvertTips;
exports.fudouTransferLogList = fudouTransferLogList;
exports.getSendLogs = getSendLogs;
exports.integralLogSaveApi = integralLogSaveApi;
exports.integralLogSaveWithFileApi = integralLogSaveWithFileApi;
exports.listsApi = listsApi;
exports.projectRechargeRecordListApi = projectRechargeRecordListApi;
exports.saveApi = saveApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 新增
 */
function saveApi(data) {
  return (0, _request.default)({
    url: "/admin/customers/integral/save",
    method: 'POST',
    data: data
  });
}

/**
 * 获取客户
 */
function activeCustomersApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/active-customers",
    method: 'GET',
    params: params
  });
}

/**
 * 列表
 */
function listsApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/integral/list",
    method: 'GET',
    params: params
  });
}

/**
 * 发放/回收
 */
function integralLogSaveApi(data) {
  // 确保销售价是数字
  var processedData = _objectSpread({}, data);
  if (processedData.salesPrice && !isNaN(processedData.salesPrice)) {
    processedData.salesPrice = Number(processedData.salesPrice);
  }
  return (0, _request.default)({
    url: "/admin/customer/integral-log/save",
    method: 'POST',
    data: processedData
  });
}

/**
 * 发放/回收（带文件上传）
 */
function integralLogSaveWithFileApi(formData) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/save",
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 项目充值记录查询
 */
function projectRechargeRecordListApi(params) {
  return (0, _request.default)({
    url: "/admin/customer/integral-log/project/recharge-records",
    method: 'GET',
    params: params
  });
}

/**
 * 客户员工列表
 */
function empListApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/emp/list",
    method: 'GET',
    params: params
  });
}

/**
 * 删除
 */
function deleteApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/integral/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 编辑
 */
function editApi(data) {
  return (0, _request.default)({
    url: "/admin/customers/integral/update",
    method: 'POST',
    data: data
  });
}

/**
 * 发放批次查询
 */
function getSendLogs(data) {
  var _ref = data || {},
    customerId = _ref.customerId,
    integralId = _ref.integralId,
    empIds = _ref.empIds;
  return (0, _request.default)({
    url: "/admin/customer/integral-log/send/log/".concat(customerId, "/").concat(integralId),
    method: 'post',
    data: {
      empIds: empIds
    }
  });
}

/**
 * 导出用户福豆数据
 */
function exportUserFudou(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/user/fudou/export',
    method: 'GET',
    params: data
  });
}

/**
 * 福豆转移前弹窗
 */
function fudouConvertTips(params) {
  return (0, _request.default)({
    url: '/admin/customers/integral/fudouConvertTips',
    method: 'GET',
    params: params
  });
}

/**
 * 福豆转移
 */
function fudouConvert(params) {
  return (0, _request.default)({
    url: '/admin/customers/integral/fudouConvert',
    method: 'GET',
    params: params
  });
}

/**
 * 福豆转移记录列表
 */
function fudouTransferLogList(params) {
  return (0, _request.default)({
    url: '/admin/customers/integral/fudouTransferLogList',
    method: 'GET',
    params: params
  });
}